// src/services/authService.js
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { auth, db } from './firebase';

export const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;

        // usersコレクションにユーザー情報が存在するかチェック
        const userDocRef = doc(db, 'users', user.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (!userDocSnap.exists()) {
            // 新規ユーザーの場合、contributorロールでusersコレクションに情報を追加
            const newUserData = {
                email: user.email,
                displayName: user.displayName,
                accountId: null, // アカウント作成時に紐付け
                role: 'contributor', // 初回ログイン時はcontributor
                createdAt: Timestamp.now(),
                updatedAt: Timestamp.now(),
            };
            await setDoc(userDocRef, newUserData);

        }

        return user;
    } catch (error) {
        console.error('Error signing in with Google:', error.message);
        // エラータイプに基づいて適切なメッセージを返す
        if (error.code === 'auth/popup-closed-by-user') {
            alert('ログインがキャンセルされました。');
        } else {
            alert(`ログイン中にエラーが発生しました: ${error.message}`);
        }
        return null;
    }
};

export const signOutUser = async () => {
    try {
        await signOut(auth);

    } catch (error) {
        console.error('Error signing out:', error.message);
        alert(`ログアウト中にエラーが発生しました: ${error.message}`);
    }
};

export const getCurrentUser = () => {
    return auth.currentUser;
};